import { injectable } from 'inversify';

import type {
  ChangeSubscription,
  FetchReceipt,
  GetActivePayment,
  GetActiveSubscription,
  GetAllTransactions,
  GetPaymentDetails,
  GetSubscriptions,
  GetTransactions,
  UpdateCardDetails,
  UpdateSubscription,
} from '../../../../types/subscription';
import SubscriptionService from '../SubscriptionService';

@injectable()
export default class StreamIQSubscriptionService extends SubscriptionService {
  getActiveSubscription: GetActiveSubscription = async () => {
    return null;
  };

  getAllTransactions: GetAllTransactions = async () => {
    return [];
  };

  getActivePayment: GetActivePayment = async () => {
    return null;
  };

  getSubscriptions: GetSubscriptions = async () => {
    return {
      errors: [],
      responseData: {
        items: [],
      },
    };
  };

  updateSubscription: UpdateSubscription = () => {
    throw new Error('Not implemented');
  };

  fetchReceipt: FetchReceipt = async () => {
    throw new Error('Not implemented');
  };

  // optional
  changeSubscription?: ChangeSubscription | undefined;
  updateCardDetails?: UpdateCardDetails | undefined;
  getPaymentDetails?: GetPaymentDetails | undefined;
  getTransactions?: GetTransactions | undefined;
}
